module.exports = __webpack_public_path__ + "static/media/weather3.a67f8cd0.jpg";